var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardiogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.6 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 18139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8 1.4C5-1.8.1 1 0 4.8a4.7 4.7 0 0 0 .9 2.7h3.8l.6-1a.5.5 0 0 1 1 0l1.3 2 2.1-4a.5.5 0 0 1 1 0l1.7 3h4.3c3.2-4.7-3.1-10-8-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.4 1c-1 0-2 .4-3 1.2l-.6.5-.6-.5c-1-.8-2-1.2-3-1.2C2.9 1 1 2.7 1 4.8c0 .6.1 1.2.4 1.7h2.7l.4-.6c.3-.4.7-.7 1.3-.7.5 0 1 .3 1.2.7l.5.7L8.8 4c.3-.5.8-.8 1.4-.8.5 0 1 .3 1.3.7L13 6.5h3.2c.5-1 .5-2.2 0-3.3A4.3 4.3 0 0 0 12.4 1m0-1c3.7 0 6.8 4 4.3 7.5h-4.3l-1.8-3c-.2-.4-.7-.4-.9 0l-2 4-1.5-2a.5.5 0 0 0-.9 0l-.6 1H.9c-.6-.8-1-1.8-.9-2.7C0 1 5-1.8 8.8 1.4 10 .4 11.2 0 12.4 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 18140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.7 9.2-1.5-2.5-2 4a.5.5 0 0 1-1 .1L5.7 8.6l-.4.7a.5.5 0 0 1-.4.2H1.6l6.8 6.4a.5.5 0 0 0 .8 0L16 9.5h-3.9a.5.5 0 0 1-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.3 8.8 9 11.2c-.2.5-.7.9-1.3.9-.5 0-1-.3-1.3-.7l-.7-1.1-.8.2h-.8l.9.8 3.8 3.5 3.8-3.5.9-.8H12a1.5 1.5 0 0 1-1.3-.8l-.5-.9m0-2 1.4 2.4a.5.5 0 0 0 .4.3h4l-7 6.4a.5.5 0 0 1-.7 0L1.6 9.5h3.3a.5.5 0 0 0 .4-.2l.4-.7 1.5 2.2c.3.4.8.3 1 0l2-4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiogram);
export default __webpack_public_path__ + "static/media/cardiogram.61ecb45f03d4e1ee262a47c9e35394d8.svg";
export { ForwardRef as ReactComponent };